import {
  LocationsSearchByGeoDocument,
  type LocationsSearchByGeoQuery,
  type LocationsSearchByGeoQueryVariables,
} from '../../graphql/LocationsSearchByGeo.generated';
import {
  LocationsSearchByRegionDocument,
  type LocationsSearchByRegionQuery,
  type LocationsSearchByRegionQueryVariables,
} from '../../graphql/LocationsSearchByRegion.generated';
import {
  LocationsSearchByRestaurantNameDocument,
  type LocationsSearchByRestaurantNameQuery,
  type LocationsSearchByRestaurantNameQueryVariables,
} from '../../graphql/LocationsSearchByRestaurantName.generated';

import type { Client } from 'urql';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Queries locations list based on provided restaurant name
 */
export async function locationsSearchByRestaurantNameQuery(
  client: Client,
  variables: LocationsSearchByRestaurantNameQueryVariables,
) {
  const { query } = variables;
  const queryLocations = client.query<LocationsSearchByRestaurantNameQuery>;

  return queryLocations(
    LocationsSearchByRestaurantNameDocument,
    { query },
    { requestPolicy: 'network-only' },
  ).toPromise();
}

export async function locationsSearchByGeoQuery(
  client: Client,
  variables: LocationsSearchByGeoQueryVariables,
) {
  const { latitude, longitude, radius } = variables;
  const queryLocations = client.query<LocationsSearchByGeoQuery>;

  return queryLocations(
    LocationsSearchByGeoDocument,
    { latitude, longitude, radius },
    { requestPolicy: 'network-only' },
  ).toPromise();
}

export async function locationsSearchByRegion(
  client: Client,
  variables: LocationsSearchByRegionQueryVariables,
) {
  const queryLocations = client.query<LocationsSearchByRegionQuery>;

  return queryLocations(LocationsSearchByRegionDocument, variables, {
    requestPolicy: 'network-only',
  }).toPromise();
}
